import { defineRoutes } from '../utils';

/**
 * Embedded financing — MVP routes.
 *
 * - `financing` — authed carrier landing page (hero + 3-step
 *   explainer + benefits + inline apply form + applications table).
 *   Lives inside `<ProtectedRoute><DashboardLayout>` like the other
 *   dashboard routes.
 * - `financing_lender_view` — the **public**, per-application
 *   lender-view page at `/financing-application/:appId?i=<lenderId>`.
 *   No token; the `?i=` carries the canonical `Lender._id` from
 *   `application.offers[i].lender._id`. Contact info on the page is
 *   masked until the lender clicks "I'm interested". See
 *   `docs/financing/partner-access.md` for the trust model.
 *   `financing_partner` is the legacy alias (kept one release for
 *   in-flight invite emails) — it redirects to `financing_lender_view`.
 */
export const financingRoutes = defineRoutes({
  financing: {
    path: '/financing',
    isPublic: false,
    // Optional deep-link params:
    //  - `invoiceId` — pre-selects the matching Hero invoice in
    //    the apply wizard. Used exclusively by "Finance it now"
    //    from invoice surfaces (`InvoiceDrawer`, `InvoiceTableManager`).
    //    Consumed (and stripped from the URL) by `ApplyForm`'s
    //    deep-link effect.
    //  - `tab` — which top-level tab to land on (default
    //    `overview`). Used together with `invoiceId` so the
    //    "Finance it now" CTA in `InvoiceDrawer` lands the user
    //    straight on the apply form instead of forcing them to
    //    click into Apply manually.
    //  - `applicationId` — pre-expands the matching row on the
    //    history tab. Used by the invoice drawer's active-
    //    financing banner ("View application").
    params: {} as {
      invoiceId?: string;
      tab?: 'overview' | 'apply' | 'history' | 'learn';
      applicationId?: string;
    },
  },
  financing_lender_view: {
    path: '/financing-application/:appId',
    isPublic: true,
    params: {} as { appId: string },
  },
  financing_partner: {
    path: '/financing/partner/:appId',
    isPublic: true,
    params: {} as { appId: string },
  },
});
